import type { EmptyFeatureResult, SignalStoreFeatureResult, SignalStoreFeature } from '@ngrx/signals'

/**
 * Adds a noop feature to the store.
 * @returns {SignalStoreFeature<Input, EmptyFeatureResult>}
 */
export function withNoop<Input extends SignalStoreFeatureResult>(): SignalStoreFeature<Input, EmptyFeatureResult> {
  return store => store
}
